import React from 'react'

export const TopNav = () => {
    return (
        <div>
            <div class="pre-header">
                <div class="container">
                    <div class="row top-navbar">
                        <div class="col-lg-8 col-sm-8 col-7 top-navbar-items">
                            <ul class="info">
                                <li><a href="tel:9530688807"><i class="fa fa-phone"></i>+91 9530688807</a></li>
                                <li><a href="mailto:info@frishtey.com"><i class="fa fa-envelope"></i>info@frishtey.com</a></li>

                            </ul>
                        </div>
                        <div class="col-lg-4 col-sm-4 col-5 top-navbar-items">
                            <ul class="social-media">
                                <li><a href="https://www.facebook.com/Frishtey"><i class="fa fa-facebook"></i></a></li>
                                <li><a href="https://in.pinterest.com/frishteymedia/"><i class="fa fa-pinterest"></i></a></li>
                                <li><a href="https://www.instagram.com/frishtey.official"><i class="fa fa-instagram"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
